import { all } from 'redux-saga/effects';
import EventSaga from '../../core/events/saga';
import NotificationSaga from '../../core/notifications/sagas';
import RatingSaga from '../../core/ratings/sagas';
import UserSaga from '../../core/users/sagas';
import VenueSaga from '../../core/venues/saga';
import VendorEventSaga from '../../core/vendor-events/saga';
import ChatSaga from '../../core/chat/saga';
import CategorySaga from '../../core/categories/saga';
import BalanceSaga from '../../core/balance/saga';
import SystemParametersSaga from '../../core/system-parameters/saga';
import LocationSaga from '../../core/location/saga';
import RetailProfilesSaga from '../../core/retail-profiles/saga';
import VendorRetailSaga from '../../core/vendor-retail/saga';

export default function* rootSaga() {
  yield all([
    EventSaga(),
    UserSaga(),
    VenueSaga(),
    RatingSaga(),
    NotificationSaga(),
    VendorEventSaga(),
    ChatSaga(),
    CategorySaga(),
    BalanceSaga(),
    SystemParametersSaga(),
    LocationSaga(),
    RetailProfilesSaga(),
    VendorRetailSaga(),
  ]);
}
